"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compareVersions = compareVersions;
exports.padNumber = padNumber;

/**
 * @module ol/string
 */

/**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number} [opt_precision] Precision of the output string (i.e. number of decimal places)
 * @return {string} Formatted string
 */
function padNumber(number, width, opt_precision) {
  var numberString = opt_precision !== undefined ? number.toFixed(opt_precision) : '' + number;
  var decimal = numberString.indexOf('.');
  decimal = decimal === -1 ? numberString.length : decimal;
  return decimal > width ? numberString : new Array(1 + width - decimal).join('0') + numberString;
}
/**
 * Adapted from https://github.com/omichelsen/compare-versions/blob/master/index.js
 * @param {string|number} v1 First version
 * @param {string|number} v2 Second version
 * @return {number} Value
 */


function compareVersions(v1, v2) {
  var s1 = ('' + v1).split('.');
  var s2 = ('' + v2).split('.');

  for (var i = 0; i < Math.max(s1.length, s2.length); i++) {
    var n1 = parseInt(s1[i] || '0', 10);
    var n2 = parseInt(s2[i] || '0', 10);

    if (n1 > n2) {
      return 1;
    }

    if (n2 > n1) {
      return -1;
    }
  }

  return 0;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUlBOzs7Ozs7QUFNTSxTQUFVQSxTQUFWLENBQW9CQyxNQUFwQixFQUE0QkMsS0FBNUIsRUFBbUNDLGFBQW5DLEVBQWdEO0VBQ3BELElBQU1DLFlBQVksR0FDaEJELGFBQWEsS0FBS0UsU0FBbEIsR0FBOEJKLE1BQU0sQ0FBQ0ssT0FBUCxDQUFlSCxhQUFmLENBQTlCLEdBQThELEtBQUtGLE1BRHJFO0VBRUEsSUFBSU0sT0FBTyxHQUFHSCxZQUFZLENBQUNJLE9BQWIsQ0FBcUIsR0FBckIsQ0FBZDtFQUNBRCxPQUFPLEdBQUdBLE9BQU8sS0FBSyxDQUFDLENBQWIsR0FBaUJILFlBQVksQ0FBQ0ssTUFBOUIsR0FBdUNGLE9BQWpEO0VBQ0EsT0FBT0EsT0FBTyxHQUFHTCxLQUFWLEdBQ0hFLFlBREcsR0FFSCxJQUFJTSxLQUFKLENBQVUsSUFBSVIsS0FBSixHQUFZSyxPQUF0QixFQUErQkksSUFBL0IsQ0FBb0MsR0FBcEMsSUFBMkNQLFlBRi9DO0FBR0Q7QUFFRDs7Ozs7Ozs7QUFNTSxTQUFVUSxlQUFWLENBQTBCQyxFQUExQixFQUE4QkMsRUFBOUIsRUFBZ0M7RUFDcEMsSUFBTUMsRUFBRSxHQUFHLENBQUMsS0FBS0YsRUFBTixFQUFVRyxLQUFWLENBQWdCLEdBQWhCLENBQVg7RUFDQSxJQUFNQyxFQUFFLEdBQUcsQ0FBQyxLQUFLSCxFQUFOLEVBQVVFLEtBQVYsQ0FBZ0IsR0FBaEIsQ0FBWDs7RUFFQSxLQUFLLElBQUlFLENBQUMsR0FBRyxDQUFiLEVBQWdCQSxDQUFDLEdBQUdDLElBQUksQ0FBQ0MsR0FBTCxDQUFTTCxFQUFFLENBQUNOLE1BQVosRUFBb0JRLEVBQUUsQ0FBQ1IsTUFBdkIsQ0FBcEIsRUFBb0RTLENBQUMsRUFBckQsRUFBeUQ7SUFDdkQsSUFBTUcsRUFBRSxHQUFHQyxRQUFRLENBQUNQLEVBQUUsQ0FBQ0csQ0FBRCxDQUFGLElBQVMsR0FBVixFQUFlLEVBQWYsQ0FBbkI7SUFDQSxJQUFNSyxFQUFFLEdBQUdELFFBQVEsQ0FBQ0wsRUFBRSxDQUFDQyxDQUFELENBQUYsSUFBUyxHQUFWLEVBQWUsRUFBZixDQUFuQjs7SUFFQSxJQUFJRyxFQUFFLEdBQUdFLEVBQVQsRUFBYTtNQUNYLE9BQU8sQ0FBUDtJQUNEOztJQUNELElBQUlBLEVBQUUsR0FBR0YsRUFBVCxFQUFhO01BQ1gsT0FBTyxDQUFDLENBQVI7SUFDRDtFQUNGOztFQUVELE9BQU8sQ0FBUDtBQUNEIiwibmFtZXMiOlsicGFkTnVtYmVyIiwibnVtYmVyIiwid2lkdGgiLCJvcHRfcHJlY2lzaW9uIiwibnVtYmVyU3RyaW5nIiwidW5kZWZpbmVkIiwidG9GaXhlZCIsImRlY2ltYWwiLCJpbmRleE9mIiwibGVuZ3RoIiwiQXJyYXkiLCJqb2luIiwiY29tcGFyZVZlcnNpb25zIiwidjEiLCJ2MiIsInMxIiwic3BsaXQiLCJzMiIsImkiLCJNYXRoIiwibWF4IiwibjEiLCJwYXJzZUludCIsIm4yIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNyYy9zdHJpbmcuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=